import StarIcon from "@mui/icons-material/Star";
import ArchiveIcon from "@mui/icons-material/Archive";
import DeleteIcon from "@mui/icons-material/Delete";

export const items = [
    { id: 1, enTitle: 'Favorite', title: 'موارد دلخواه', icon: <StarIcon fontSize='large' style={{ color: 'rgba(255,196,44,1)' }} /> },
    { id: 2, enTitle: 'Archive', title: 'بایگانی', icon: <ArchiveIcon fontSize='large' /> },
    { id: 3, enTitle: 'Trash', title: 'سطل زباله', icon: <DeleteIcon fontSize='large' /> },
]